// import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import {  VueAxios } from './axios'
import { Toast } from 'vant'
import { channel_id, tenantId, edition, channel } from '@/components/config'
import { getUrlKey, getCookie,getCookieuUne } from '@/utils/util'
// 解析post方式的字符串
import qs from 'qs'
// 引入路由router
import router from '@/router'
// import { ACCESS_TOKEN } from '@/store/mutation-types'
let inApp = false
// 创建 axios 实例
console.log('环境', process.env.NODE_ENV, process.env.VUE_APP_requestUrl, tenantId)
// 是否展示错误弹窗
let noToastFlag = []
const urlHead = process.env.NODE_ENV.includes('dev') ? '/api' : process.env.VUE_APP_requestUrl // api base_url
const service = axios.create({
  baseURL: urlHead,
  headers: { 'Accept-Language':'en'}, // 应后端要求活动列表必传字段
  timeout: 20000 // 请求超时时间
})

const err = (error) => {
  if (error.response) {    // const data = error.response.data
    // const token = Vue.ls.get(ACCESS_TOKEN)
    // if (error.response.status === 403) {
    //   Toast.fail(data.message)
    // }
    // if (error.response.status === 401) {
    //   Toast.fail('Authorization verification failed')
    //   if (token) {
    //     store.dispatch('Logout').then(() => {
    //       setTimeout(() => {
    //         window.location.reload()
    //       }, 1500)
    //     })
    //   }
    // }
  }
  return Promise.reject(error)
}


// 生成通用必传参数
const createParameters = function () {
  inApp = (getUrlKey('appType') === 'android' || getUrlKey('appType') === 'ios' || getCookie('publicParams'))
  let params = {
    r: channel_id, // 院线渠道 1=大地，2=嘉禾,
    t: 3, // 终端软件类型 1: ios 2: Android 3: h5 4: 5:小程序 7：pc端
    v: edition, // 终端软件版本号
    d: 'iphone7', // 终端设备型号,
    s: 'ios10.1', // 终端设备系统版本,
    i: '127.0.0.1', // 8682165971750150,
    tenantId,
    unifiedCode: store.state.cityList.cinemaInfo.cinemaCode || '0',
    k:store.state.shortToken,  // 访问的会话token
    // 后端无沟通，导致渠道传参不统一....
    channelNo: channel.no,
    channelCode: channel.no,
    channelName: channel.name,
    unifiedCinemaId: store.state.cityList.cinemaInfo.cinemaId,
    unifiedCinemaName: store.state.cityList.cinemaInfo.cinemaName,

  }

  return params
}
// 封装拼接通用必传参数
const addParameters = function (config) {
  const parameters = createParameters()
  // 确认订单 需要json
  if(config.headers['Content-Type'] === 'application/json'){
    config.data = {
      ...parameters,
      ...config.data
    }
  } else if (config.method === 'get') {
    config.params = {
      ...parameters,
      ...config.params
    }
    
  } else if (config.method === 'post') {
    let data = qs.parse(config.data)
    config.data = qs.stringify({
      ...parameters,
      ...data
    })
  }
  return config
}



// 检测长token是否存在，是否过期
const validateLongToken = function (resConfig) {
  console.log(123123123123)
  const lToken = store.state.longToken
  // 如果长token存在，请求静默登录
  if (lToken) {
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept-Language':'en'
      }
    }
    // lt
    const parameters = createParameters()
    let postData = qs.stringify({
      lToken,
      ...parameters
    })
    axios.post(urlHead + '/user/slogin', postData, config).then(function (res) {
      // 如果成功的话，将该接口返回的长token覆盖本地存储。再利用具有登录权限的短token重新请求接口
      if (res.data.success) {
        store.commit('setLongToken', res.data.data.ltoken)
        store.commit('userInfo', res.data.data)
        // FIXME:再次发送之前请求
        // const params = getLastParas(resConfig)
        // return axios(params).then(function (res) {
        //   return Promise.resolve(res.data)
        // })
        console.log(2222)
        // window.location.reload()
        // return api({ method: params.method, data: params.method === 'get' ? params.params : params.data }, params.url)
      }
      // 如果长token过期的话，跳转登录页---需要携带过去该页的整个路径 1060003长token失效
      if (!res.data.success) {
        debugger
        console.log('请重新登录')
        store.commit('setUserInfo', '')
        router.push({
          name: '/login/index',
          query: { redirect: router.currentRoute.fullPath }
        })
      }
    })
  }
  else {
    // FIXME:长token不存在，说明之前的短token是未登录的，利用现在的短token重新请求接口
    // const params = getLastParas(resConfig)
    // return axios(params).then((res) => {
    //   return Promise.resolve(res.data)
    // })
    console.log(333)
     window.location.reload()
    // return api({ method: params.method, data: params.method === 'get' ? params.params : params.data }, params.url)
  }
}
// 请求拦截器
service.interceptors.request.use(config => {
  // //设置7天登录
  // (function(){
  //   var sessionToken = window.sessionStorage.getItem("token");
  //   var cookToken = getCookieuUne("token");
  //   if(sessionToken){
  //     store.commit('memoryData',{'shortToken':sessionToken})
  //     return
  //   }else if(cookToken&&cookToken!='null'){
  //     store.commit('memoryData',{'shortToken':cookToken})
  //     return
  //   }else{
  //     store.commit('memoryData',{'shortToken':'0'})
  //   }
  // })()
  // 在此添加参数，这里只会当接口被调用时才会真正触发
  config = addParameters(config)
  return config
}, err)

// 响应拦截器
service.interceptors.response.use((resConfig) => {
   
  // 拦截长token, 用户未登录或者登录失效
  if (resConfig.data.code === 1060000 ) {
    debugger;
    console.log('请重新登录')
    console.log(store)
    store.commit('setUserInfo', '')
    router.push({
      name: '/login/index',
      query: { redirect: router.currentRoute.fullPath }
    })
    if (resConfig.data.msg && resConfig.data.code != '1060000') {
      Toast(resConfig.data.msg)
    }
    
    return resConfig.data
  }
  // 拦截短token过期--本地短token可能存在,但是后端返回过期。重新获取短token,判断长token是否存在，如果存在并且过期，跳转登录页。如果不存在，说明不必登录,只需短token重新设置即可。
  else if (resConfig.data.code === 1060001) {
    // 没有token的话请求接口获取，注意这里的路径，由于是devserver的proxy代理
    return axios.post(urlHead + '/token/add', qs.stringify(createParameters())).then(function (res) {
      // 请求成功，存储token
      if (res.data.success) {
        // 短token过期的话，在请求新token之后，要重新请求接口
        window.sessionStorage.setItem("token",res.data.data);
        store.commit('setShortToken', res.data.data)
        // 如果本地存储长token存在，进行静默登录，过期的话--->跳转登录页。
        return new Promise(function (resolve) {
          resolve(validateLongToken(resConfig))
        })
      } else {
        Toast('网络错误,请稍后再试~')
        return Promise.resolve('网络错误,请稍后再试~')
      }
    })
  }
  else if (resConfig.data.code === 200) {
    return resConfig.data
  } else {
    if (resConfig.data.msg && !noToastFlag.includes(resConfig.config.url)) {
      // Toast(`${resConfig.config.url.split('/').pop()}|${resConfig.data.msg}`)
      Toast(`${resConfig.data.msg}`)
    }
    return Promise.resolve(resConfig.data)
  }
}, err)

let noGetAdd = true
function api ({ method, data, contentType = 'urlencoded', noToast = false, payHeader = false }, url) {
  if(noToast){
    noToastFlag.push(url)
  }
  console.log("store.state.shortToken",store.state.shortToken)
  // 1.判断本地是否有token
  if (store.state.shortToken === '0' && noGetAdd) {
    noGetAdd = false
    return new Promise( (resolve, reject) => {
      // 没有token的话请求接口获取，注意这里的路径，由于是devserver的proxy代理
     axios.post(urlHead + '/token/add', qs.stringify(createParameters())).then(function (res) {
      // 请求成功，存储token
      if (res.data.success) {
        
        //window.sessionStorage.setItem("token",this.$store.state.shortToken);
        store.commit('setShortToken', res.data.data)
        // 存储token后，拼接通用必传参数
        // 由于二次请求的异步，第一次请求不能得到合理的参数，所以重新进行第一次请求
        return resolve(api({ method, data }, url))
      } else {
        return reject(res.data)
      }
    })
    })
    
  } else {
    // 2.有token的话
    if (method && method.toLowerCase() === 'get') {
      return service.get(url, {params: data})
    } else {
      var contentTypeObj = {
        urlencoded: 'application/x-www-form-urlencoded',
        json: 'application/json',
        formData: 'multipart/form-data'
      }

      const config = {
        headers: {
          'Content-Type': contentTypeObj[contentType],
          'Accept-Language':'en'
        }
      }
      if(payHeader){
        config.headers['c-User-Token'] = createParameters().k
        config.headers['c-tenantId'] = createParameters().tenantId
      }
      
      if(contentType === 'json'){
        data = qs.parse(data)
      }
      return service.post(url, data, config)
    }
  }
}

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, service)
  }
}

export {
  installer as VueAxios,
  api as axios,
  createParameters,
  urlHead
}



// WEBPACK FOOTER //
// ./src/utils/http.js